if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    $('.sym-slides-default').slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
     });

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    let headerBooking = document.querySelector(".js-toggleBooking");

    if (headerBooking) {
        let span = headerBooking.getElementsByTagName("span")[0] || headerBooking;
        let contentText = span.textContent;

        headerBooking.addEventListener("click", (e) => {
            e.preventDefault();
            headerBooking.classList.toggle("active");
            span.textContent = headerBooking.classList.contains("active") ? "CLOSE" : contentText;
        });
    }


    const prevArrowHTML =
        `<button aria-label="prev image" class="slick-arrow slick-next prevHiddenClick">
        </button>`;
    const nextArrowtHTML =
        `<button aria-label="next image" class="slick-arrow slick-next">
            <span class="nextArrow"></span>
            <span class="prevArrow"></span>
            <svg width="100" height="100" viewBox="0 0 72 72" preserveAspectRatio="none" fill="none" stroke="#93ADB4" stroke-width="1">
                <circle stroke="#fff" vector-effect="non-scaling-stroke" cx="36" cy="36" r="35" />
                <circle class="hover" vector-effect="non-scaling-stroke" cx="36" cy="36" r="34" stroke-width="4" />
            </svg>
        </button>`;

    const slickOptions = {
        accessibility: true,
        prevArrow: prevArrowHTML,
        nextArrow: nextArrowtHTML
    };


    $('.sym-slides-slider').slick({
        arrows:true,
        dots:false,
        fade:true,
        speed:1000,
        accessibility: false,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        fade: true,
        pauseOnDotsHover: false,
        appendArrows:$('.top-content-home__bottom_container .top-content-home__arrows'),
        nextArrow:slickOptions.nextArrow,
        prevArrow:slickOptions.prevArrow
    });  

    $('.sym-slides').slick({
        fade: true,
     });
    //Slider shortcode reviews
    $('.reviews').slick({
        fade: true,
        accessibility: false,
        autoplay:true
    })

    //Slider shortcode slider-V2
    $('.sym-slider-v2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay:false,
        fade: true,
        asNavFor: '.slider-nav-v2',
        draggable: false,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        autoplaySpeed: 6000
    });
    $('.slider-nav-v2').slick({
        autoplay:false,
        slidesToShow: 5,
        slidesToScroll: 1,
        variableWidth:true,
        asNavFor: '.sym-slider-v2',
        dots: false,
        focusOnSelect: true,
        autoplaySpeed: 6000
    });  

    //Slider shortcode Two Options
    $('.sym-two-options').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay:false,
        fade: true,
        asNavFor: '.sym-two-nav',
        draggable: false,
        swipe: false,
        swipeToSlide: false,
        touchMove: false
    });
    $('.sym-two-nav').slick({
        slidesToShow: 4,
        autoplay:false,
        slidesToScroll: 1,
        variableWidth:true,
        asNavFor: '.sym-two-options',
        dots: false,
        focusOnSelect: true,
    });


    //Slider inmersive
    $('.sym-slider-inmersive').slick({
        accessibility:true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        asNavFor: '.slider-inmersive-nav',
        infinity:false,
        responsive: [
            {
            breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                },
            }
        ]
      });

      $('.slider-inmersive-nav').slick({
        accessibility:true,
        infinity:false,
        fade:false,
        slidesToShow: 8,
        slidesToScroll: 1,
        asNavFor: '.sym-slider-inmersive',
        dots: false,
        focusOnSelect: true
      });

      $('.sym-slider-specials').slick({
        accessibility:true,
        infinity:true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        autoplay:true,
        autoplaySpeed: 3000,
      });

      $('.sym-slider-carousel').slick({
        accessibility:true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinity:false,
        responsive: [
            {
              breakpoint: 724,
              settings: {
                // centerMode: true,
                // variableWidth: true,
                infinite: true,
                dots: true
              }
            }
        ]
      });
      $('.sym-slider-carousel-single').slick({
        accessibility:true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinity:false,
        autoplay:true,
        autoplaySpeed: 3000,
        responsive: [
            {
              breakpoint: 724,
              settings: {
                // centerMode: true,
                // variableWidth: true,
                autoplay: true,
                infinite: true,
                dots: false
              }
            }
        ]
      });

    // Slider Inmersive Altern
    $('.gallery-inmersive-slider').slick({
        arrows:true,
        dots:false,
        speed:1000,
        accessibility: true,
        autoplay: false,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-nav',
        prevArrow: '.js-slick-prev',
        nextArrow: '.js-slick-next',
        responsive: [
            {
            breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                },
            }
        ]
    })

    $('.slider-nav').slick({
        arrows:false,
        dots:false,
        speed:1000,
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        slidesToScroll: 1,  
        asNavFor: '.gallery-inmersive-slider',
    });

    $('.js-slider-thumbnails').on('init', function(event, slider) {
        var $slickDots = $(slider.$dots);
        var $prevArrow = $(slider.$prevArrow);
        var $nextArrow = $(slider.$nextArrow);

        if ($slickDots.length && $prevArrow.length && $nextArrow.length) {
            var $arrowsLi = $('<li class="circle-arrows"></li>');
            $arrowsLi.append($prevArrow);
            $arrowsLi.append($nextArrow);

            $slickDots.append($arrowsLi);
        }
    })

    $('.js-slider-thumbnails').slick({
        fade: true,
        dots: true,
        customPaging: function(slider, i) {
            let thumb = $(slider.$slides[i]).data("thumb");
            let text = $(slider.$slides[i]).data("text");
            return `<button type="button" style="--img: url(${thumb});" class="${text.length > 1 ? 'long' : ''}">${text}</button>`;
        }
    });

    $('.js-gallery-list').slick({
        slidesToShow: 3,
        dots: true,
        customPaging: function(slider, i) {
            let thumb = $(slider.$slides[i]).data("thumb");
            return `<button type="button" style="--img: url(${thumb})">${i + 1}</button>`;
        },
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                },
            }
        ]
    });

    if(document.getElementById("fsCountdown")){
        const fsCountdown = new Date(document.getElementById('fsCountdown').getAttribute('data-time'));
          //countdown
          let fsDays = 0;
          let fsHours = 0;
          let fsMinutes = 0;
          let fsSeconds = 0;
          tick();
          let fsTimer = setInterval(tick.bind(this), 1000);
       
        function updateRemaining(fsDistance) {
          fsDays = Math.floor(fsDistance / (1000 * 60 * 60 * 24));
          fsHours = Math.floor((fsDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          fsMinutes = Math.floor((fsDistance % (1000 * 60 * 60)) / (1000 * 60));
          fsSeconds = Math.floor((fsDistance % (1000 * 60)) / 1000);
      
          document.getElementById('fsDays').innerHTML = fsDays;
          document.getElementById('fsHours').innerHTML = fsHours;
          document.getElementById('fsMinutes').innerHTML = fsMinutes;
          document.getElementById('fsSeconds').innerHTML = fsSeconds;
        }
        function tick() {
          const currentTime = new Date();
          const fsDistance = Math.max(fsCountdown - currentTime, 0);
          updateRemaining(fsDistance);
          
          if (fsDistance === 0) {
            clearInterval(fsTimer);
          }
        };
      }

      //email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		}) 
		 document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		 })

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}


    // End Slider inmersive

    //Validation footer for padding top if it has slider inmersive quad
    let footer = document.querySelector('#footer_main');
    // find all section and verify if the last item has slider
    let main = document.querySelectorAll('#content section');
    let mainLenght = main.length-1;

    main.forEach((section,position) => {
        //verify the last quad if it has slider
        if(position == mainLenght){
            if (section.classList.contains('js-slider-inmersive')){
                footer.classList.add('js-footer-hight-slider');
                section.classList.add('js-slider-inside-footer');

            }
        }
    })

  
    //------------------End Validation -----------------


    $('.js-slick-prev').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
         $curSlider.slick('slickPrev');
    });
    $('.js-slick-next').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
         $curSlider.slick('slickNext');
    });

    $('.sym-slides-home').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        fade: true,
        pauseOnDotsHover: false,
        nextArrow:slickOptions.nextArrow,
        prevArrow:slickOptions.prevArrow
    });


    //--------------------------------------------------------
    //-------------- SECTION FOR ARROWS SLIDERS --------------
    //--------------------------------------------------------
    //HOVER for All sliders and arrows
    // let arrowNext = document.querySelectorAll(".js-slick-next");
    // let arrowPrev = document.querySelectorAll(".js-slick-prev");

    // //validate if the view had arrows and listen the event 
    // if(arrowPrev != undefined && arrowNext != undefined){
    //     arrowNext.forEach(selectArrow => {
    //         selectArrow.addEventListener("mouseover", showArrow);
    //         selectArrow.addEventListener("mouseout", hiddenArrow);
    //     })
    //     arrowPrev.forEach(selectArrow => {
    //         selectArrow.addEventListener("mouseover", showArrow);
    //         selectArrow.addEventListener("mouseout", hiddenArrow);
    //     })
    //  }
    // //it shows the hidden arrow and hide the new arrow
    //  function showArrow(){
    //     if(this.classList.contains("js-slick-next")){
    //         this.style.opacity = 1;
    //         this.previousElementSibling.style.opacity = 0;
    //     }
    //     else if(this.classList.contains("js-slick-prev")){
    //         this.style.opacity = 1;
    //         this.nextElementSibling.style.opacity = 0;
    //     }
    // }
    // //return the arrow to the original position "Right"
    // function hiddenArrow(){
    //     if(this.classList.contains("js-slick-next")){
    //         this.style.opacity = 0;
    //         this.previousElementSibling.style.opacity = 1;
    //     }
    //     else if(this.classList.contains("js-slick-prev")){
    //         this.style.opacity = 0;
    //         this.nextElementSibling.style.opacity = 1;
    //     }
    // }

    //--------------------------------------------------------
    //------------------- END ARROWS SLIDER ------------------
    //--------------------------------------------------------



    // -------------------------------------------------------
    // --------------  NAVEGATION MENU -----------------------
    // -------------------------------------------------------
    
    let menu = document.querySelectorAll("#menuHeader")[0];
    if(menu!= undefined){
        menu.addEventListener('click', showMenu);
    }

    function showMenu (){
        let menuItems = document.querySelectorAll("#menuSection")[0];
        if(menuItems.classList.contains("hidden")){
            menuItems.classList.remove("hidden");
            menu.classList.add("open-menu");
        }
        else{
            menuItems.classList.add("hidden");
            menu.classList.remove("open-menu");
        }
    }
    // -------------------------------------------------------
    // -------------- END NAVEGATION MENU --------------------
    // -------------------------------------------------------

    // -------------------------------------------------------
    // ------------------ ACCORDION -------------------
    // -------------------------------------------------------
    var accordionItems = document.querySelectorAll('.accordion__item');
    var i;
    for (i = 0; i < accordionItems.length; i++) {
        let disItem = accordionItems[i];
        let disBtn = disItem.querySelector('.accordion__btn');
        disBtn.addEventListener('click', function () {
            disItem.classList.toggle('open');

        });
    }
    // -------------------------------------------------------
    // -------------- END  ACCORDION --------------------
    // -------------------------------------------------------

    setTimeout(function() {
        $('.sprite .page-view .project:nth-child(odd)').addClass('pattern');
    }, 1000);

 
    //Prevent Button Click navbar

    let buttonsPrevent = document.querySelectorAll('.js-no-click');
        buttonsPrevent.forEach(button=>{
        button.addEventListener('click',preventClick);
    })
    function preventClick(e){
      e.preventDefault();
    }

    // -------------------------------------------------------
    // ------------------ END CLICK -------------------------
    // -------------------------------------------------------

    document.getElementById('burgerMenu').addEventListener('click', function () {
        if (!this.classList.contains('open')) {
            this.parentElement.classList.add('open');
            this.classList.add('open');
            document.querySelector(".overlay").classList.add("open");
            document.getElementById("logo-sm").classList.remove("hidden");
            document.getElementById("social-mobile").classList.remove("hidden");
            let button = document.getElementById("Close").parentElement.parentElement;
            if (button.childNodes.length == 2) {
                let newText = document.createElement("div");
                newText.textContent = "CLOSE";
                newText.classList.add("jsCloseBtn")
                button.appendChild(newText);
            }
        }
        else {
            this.classList.remove('open');
            document.getElementById("logo-sm").classList.add("hidden");
          
            let button = document.getElementById("Close").parentElement.parentElement;
            button.removeChild();
            this.parentElement.classList.remove('open');
            document.querySelector(".overlay").classList.remove("open");
        }
    });

  //close btn mobile
  let closeBtn = document.querySelectorAll(".nav-container")[0];
  let newButton = closeBtn.childNodes[1];
  if (newButton != undefined) {
      if (closeBtn.childNodes[1].classList.contains("mobile")) {
          let generalbutton = closeBtn.childNodes[1].children[0].children[0];
          generalbutton.addEventListener('click', function () {
            document.getElementById("social-mobile").classList.add("hidden");
              document.getElementById("logo-sm").classList.add("hidden");
              document.querySelectorAll('.overlay')[0].classList.remove('open');
              document.getElementById('burgerMenu').classList.remove('open');
          })
      }
  }
    //dropdown for mobile
    document.querySelectorAll('.inner > ul > li > a').forEach(link => {
    link.addEventListener('click', e => {
        if (link.nextSibling.nextSibling != null) {
            document.querySelectorAll('.inner > ul > li').forEach(item => {
                if (link.parentNode !== item) item.classList.remove('js-submenu-show');
            });
            //remove this comment if you want show subnav for mobile
            e.preventDefault();
            link.parentNode.classList.toggle('js-submenu-show');
        }
    });
    }); 
    //add class for icon dropdown 
    document.querySelectorAll('.inner > ul > li > .sub-sub-menu').forEach(link => {
    let menu = link.parentNode.firstElementChild;
    menu.classList.add('ico-dropdown');

    //------------------------------
    //------- Section Scroll -------
    //------------------------------
      //scroll down click
	if(document.getElementsByClassName('scrollto').length > 0){
		document.getElementsByClassName('scrollto')[0].addEventListener('click', function(){
			animateTo('eventsform-form');
		});
	}

    //animation of scroll vanilla JS
    function animateTo(target){
        var gotoTarget = offset(document.getElementById(target)).top - 100;
        var from     = window.pageYOffset
        var to       = gotoTarget
        var duration = 1300; 
        var start = new Date().getTime()

        //time interval
        var timer = setInterval(function() {
            var time = new Date().getTime() - start

            if(from <= to ){
                var yH = easeInOutQuart(time, from, to - from, duration)
            } else {
                
                var yH = easeInOutQuart(time, from, -(from - to), duration)
            }
            window.scrollTo(0, yH)
            if (time >= duration) clearInterval(timer)

        }, 1000 / 60);

        window.scrollTo(0, from)

    }

    //ease movement
    function easeInOutQuart(t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
        return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
    }

    //window offset
    function offset(el) {
        var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }
      
    //------------------------------
    //------------------------------
})
})();